/* Apreels (MAIA 28/09/2026) · Cambio de variante al instante en la ficha.
   El tema pide al servidor la ficha entera (~200 KB) cada vez que se pulsa Plata / Oro / Piedra / Talla y no
   cambia nada hasta que llega (0,5–1 s, más en móvil). Aquí se cambia al momento lo que se ve (fotos, texto de la
   opción elegida y precio) con los datos que ya están en la página; la respuesta del servidor llega después y
   confirma (botón de compra, URL, stock). Datos: <script data-apr-fast> en snippets/product-media-gallery.liquid. */
(function () {
  if (window.__aprFast) return;
  window.__aprFast = true;

  function parseMap(s) {
    var m = {};
    (s || '').split('|').forEach(function (p) {
      var i = p.indexOf('=');
      if (i > 0) m[p.slice(0, i).trim()] = p.slice(i + 1).trim();
    });
    return m;
  }
  function data(sectionId) {
    var el = document.querySelector('script[data-apr-fast="' + sectionId + '"]');
    if (!el) return null;
    if (!el.__d) {
      try {
        var d = JSON.parse(el.textContent);
        d.m = parseMap(d.map);
        d.g = {};
        (d.gal || '').split(';').forEach(function (p) {
          var i = p.indexOf('=');
          if (i > 0) d.g[p.slice(0, i)] = p.slice(i + 1);
        });
        el.__d = d;
      } catch (e) { return null; }
    }
    return el.__d;
  }
  function canon(d, v) {
    v = (v || '').toLowerCase().trim();
    return d.m[v] || v;
  }
  function selected(vs) {
    var out = [];
    vs.querySelectorAll('fieldset, .product-form__input--dropdown, select').forEach(function (f) {
      if (f.tagName === 'SELECT') {
        if (!f.closest('fieldset, .product-form__input--dropdown')) out.push({ val: f.value, el: f });
        return;
      }
      var sel = f.querySelector('select');
      if (sel) { out.push({ val: sel.value, el: sel.options[sel.selectedIndex], box: f }); return; }
      var r = f.querySelector('input[type=radio]:checked');
      if (r) out.push({ val: r.value, el: r, box: f });
    });
    return out;
  }

  function apply(vs) {
    var sid = vs.dataset.section;
    var d = data(sid);
    if (!d) return;
    var sel = selected(vs);
    var cv = sel.map(function (s) { return canon(d, s.val); });

    // texto de la opción elegida ("Material: Baño de oro de 24 quilates")
    sel.forEach(function (s) {
      var lab = s.box && s.box.querySelector('[data-selected-value]');
      if (lab && s.el) lab.textContent = (s.el.dataset && s.el.dataset.aprLabel) || s.val;
    });

    // fotos: se enseña una foto si, para cada opción que nombra, lleva el valor elegido
    var ul = document.getElementById('Slider-Gallery-' + sid);
    if (ul) {
      var lis = ul.querySelectorAll('li[data-media-id]');
      lis.forEach(function (li) {
        var id = li.dataset.mediaId.split('-').pop();
        var om = d.g[id];
        if (om == null) return;
        var off = false;
        var byOpt = {};
        om.split('|').forEach(function (t) {
          var i = t.indexOf(':');
          if (i < 0) return;
          var k = t.slice(0, i);
          (byOpt[k] = byOpt[k] || []).push(t.slice(i + 1));
        });
        Object.keys(byOpt).forEach(function (k) {
          if (byOpt[k].indexOf(cv[+k]) === -1) off = true;
        });
        li.classList.toggle('apr-off', off);
        if (!off) {
          var im = li.querySelector('img[loading=lazy]');
          if (im) im.loading = 'eager';
        }
      });
      // foto de la variante, primera
      var v = null;
      for (var i = 0; i < d.v.length; i++) {
        var ok = true;
        for (var j = 0; j < cv.length; j++) if (d.v[i].o[j] !== cv[j]) { ok = false; break; }
        if (ok) { v = d.v[i]; break; }
      }
      if (v && v.f) {
        var first = ul.querySelector('li[data-media-id="' + sid + '-' + v.f + '"]');
        if (first) {
          first.classList.remove('apr-off');
          if (ul.firstElementChild !== first) ul.prepend(first);
          ul.querySelectorAll('li.is-active').forEach(function (x) { x.classList.remove('is-active'); });
          first.classList.add('is-active');
        }
      }
      ul.scrollTo && ul.scrollTo({ left: 0 });
      var slider = ul.closest('slider-component');
      if (slider && slider.initPages) try { slider.initPages(); } catch (e) {}
      // precio
      if (v && v.p) {
        var pr = document.getElementById('price-' + sid);
        if (pr) pr.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach(function (x) { x.textContent = v.p; });
      }
    }
  }

  document.addEventListener('change', function (e) {
    var vs = e.target && e.target.closest && e.target.closest('variant-selects');
    if (vs) apply(vs);
  }, true);

  // precarga, cuando la página está quieta, la primera foto de cada variante (para que al cambiar ya esté)
  function preload() {
    document.querySelectorAll('script[data-apr-fast]').forEach(function (el) {
      var sid = el.getAttribute('data-apr-fast');
      var d = data(sid);
      if (!d) return;
      var seen = {};
      d.v.forEach(function (v) {
        if (!v.f || seen[v.f]) return;
        seen[v.f] = 1;
        var li = document.querySelector('li[data-media-id="' + sid + '-' + v.f + '"]');
        var im = li && li.querySelector('img[loading=lazy]');
        if (im) im.loading = 'eager';
      });
    });
  }
  if ('requestIdleCallback' in window) window.addEventListener('load', function () { requestIdleCallback(preload, { timeout: 3000 }); });
  else window.addEventListener('load', function () { setTimeout(preload, 1500); });
})();
